import type { ComponentType } from 'react';
import { lazy } from 'react';

import { injectReact, unmountReact } from '@shared/render-utils';
import { watchInviewNodes } from '@utilities/dom';
import { Warn } from '@utilities/logging';

export class ReactLoader {
  constructor() {
    watchInviewNodes('.d3-react', this.launch.bind(this), this.detach.bind(this), {
      includeHidden: true,
    });
  }

  getScript(name: string, tag?: string): ComponentType {
    try {
      return lazy(() => import(`../../react/components/${name}/app`));
    } catch (e) {
      Warn(`Component ${name} (tag: ${tag}) does not exist`, e);
    }
  }

  launch(el: HTMLElement) {
    const name = el.dataset.name,
      tag = el.dataset.tag;

    //check if exist
    if (!name) {
      Warn('can not find component name for element', el);
      return;
    }

    const Component = this.getScript(name, tag);

    if (!Component) {
      return;
    }

    let options: any;
    try {
      options = JSON.parse(el.dataset.options ?? '{}');
    } catch (e) {
      Warn(`Options parsing error for React app ${name}`, e, options);
      options = {};
    }

    this.render(Component, options, el);
  }

  detach(el: HTMLElement) {
    unmountReact(el);
  }

  render<T>(Component: ComponentType<{ options?: T }>, options: T, el: HTMLElement) {
    injectReact(Component, { options }, el);
  }

  static readonly instance = new ReactLoader();
}

const reactLoaderInstance = ReactLoader.instance;
export default reactLoaderInstance;
